import { render, staticRenderFns } from "./location-card.vue?vue&type=template&id=7ffc1c7d"
import script from "./location-card.vue?vue&type=script&lang=js"
export * from "./location-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports